


import Vue from 'vue'
import * as turf from '@turf/turf'
import { transform } from "ol/proj";
import Overlay from 'ol/Overlay';
import VectorLayer from "ol/layer/Vector";
import Vector from 'ol/source/Vector';
import VectorSource from 'ol/source/Vector';
import { getCenter as getFeatureCenter } from 'ol/extent';
import { Feature } from 'ol';
import { Point, MultiLineString, LineString, Circle } from 'ol/geom';
import { Style, Fill as olFill, Stroke, Icon as olIcon, Text as olText, Circle as olCircle } from "ol/style";
import DragPan from 'ol/interaction/DragPan'
import * as Format from "ol/format";
import { ajax } from 'jquery';

import { postOrienTation, getSuperiorSubordinate } from "../http/axios";


import * as axios from 'axios'
import VueAxios from "vue-axios";

// Vue.use(axios)



var clickList = []
var operMode = 0;
var displayLinePathStyle = null;
var displayLinePathVectorSource = null;
var displayLinePathLayer = null;
function cleanLayerTempVisible(curZoom) {

    if (window.global.lastZoom == curZoom)
        return;
    for (let i = 0; i < window.global.layerCfg.length; i++) {
        let jl = window.global.layerCfg[i];
        if (jl.tempVisible != null) {
            jl.tempVisible = null;
            jl.loadRenderStep = 0;
            jl.tempMinZoom = null;
        }
    }
}



//菜单页
function menuClick(title, url, width, height) {
    // let lo = layer.open({
    //     type: 2,
    //     // id:layuiId,
    //     // skin: skin, //样式类名
    //     closeBtn: 1, //显示关闭按钮
    //     anim: 2,//动画
    //     title:title,
    //     area:[width+"px",height+"px"],
    //    // offset:["100px","200px"],
    //     shade: 0, //开启遮罩关闭
    //     content: url
    // });
    window.global.menu_overlay.setPosition(undefined);

}

function addRightClickEvent() {
    window.vueAddRightClick();
}
function addEquemtTree() {
    window.createEquemtTreeOverlay();
}

//图例
function updateLayerVisibleInfo() {
    let vHtml = [];
    let dealedName = [];


    for (let i = 0; i < window.global.layerCfg.length; i++) {
        let jl = window.global.layerCfg[i];
        let ly = jl.ol;
        if (ly == null)
            continue;

        let layerCtrl = window.common.safeGetJsonKey(jl, "layerCtrl", "0")
        if (layerCtrl == "0") {
            continue;
        }
        if (dealedName.indexOf(jl.name) != -1)
            continue;
        dealedName.push(jl.name)

        let ttitle = window.common.safeGetJsonKey(jl, "title", "");
        let ticon = window.common.safeGetJsonKey(jl, "icon", "");
        let tname = window.common.safeGetJsonKey(jl, "name", "");
        let ttype = window.common.safeGetJsonKey(jl, "layerControltype", "");
        let mvisible = 0;
        if (ly.getVisible()) {
            mvisible = 1;
        }
        else {
            mvisible = 0;
        }
        vHtml.push(
            {
                name: tname,
                title: ttitle,
                icon: ticon,
                visible: mvisible,
                type: ttype,
            }
        );
    }
    window.modifyLayerInfo && window.modifyLayerInfo(vHtml);

}



function getConnectPath(id, layerName) {
    var params = {
        id: id,
        class_name: layerName,

    };
    postOrienTation(params).then((resp) => {
        // console.log(resp)
        if (resp.code == 200) {
            let data = resp.data;
            if (data.length == 0) {
                return;
            }
            // console.log(data[0].gemo)
            // console.log(data[0].name)
            window.mapOperator.showSearchResultFeature(
                "",
                "",
                data[0].gemo,
                data[0].name,
                false,
                "4326"
            );
        }
    });

}

function getConnectPathGroups(id, layerName) {
    // var url = "gis/public/api/getSuperiorSubordinate?id=" + id + "&laeryName=" + layerName;
    let params = {
        "id": id,
        "laeryName": layerName
    }
    getSuperiorSubordinate(params).then((resp) => {
        // console.log(resp.data)
        if (true) {
            // 上级
            let majorNetworkList = window.common.safeGetJsonKey(resp, "majorNetworkList", []);
            let majorNetworklineStringList = window.common.safeGetJsonKey(majorNetworkList, "majorNetworklineStringList", []);
            //  下级
            // let subordinateList = window.common.safeGetJsonKey(resp.data, "subordinateList", []);
            let majorNetworkPointList = window.common.safeGetJsonKey(majorNetworkList, "majorNetworkPointList", []);
            //var getedfeatures = new GeoJSON().readFeatures(json);
            var featureCollection_superiorList = {
                'type': 'FeatureCollection',
                'features': []
            };
            var featureCollection_subordinateList = {
                'type': 'FeatureCollection',
                'features': []
            };
            for (let t = 0; t < majorNetworklineStringList.length; t++) {
                let ti = majorNetworklineStringList[t];

                showSearchResultFeature(ti.id, ti.className, ti.geomjson, ti.name, false, "3857");
            }

            for (let t = 0; t < majorNetworkPointList.length; t++) {
                let ti = majorNetworkPointList[t];
                showSearchResultFeature(ti.id, ti.className, ti.geomjson, ti.name, false, "3857");
            }
        }
    });

}
// function getTideWayLineIdList(layerList, voltageLevelFilter) {
//     let features = null;
//     let lineIdList = [];
//     let lineList = [];
//     let extent = window.global.map.getView().calculateExtent(window.global.map.getSize());
//     for (let i = 0; i < layerList.length; i++) {
//         let jl = layerList[i];
//         // features = jl.ol.getSource().getFeatures()
//         features = jl.ol.getSource().getFeaturesInExtent(extent)
//         console.log(features);
//         for (let j = 0; j < features.length; j++) {
//             let feature = features[j]
//             let voltage_type = window.common.safeGetJsonKey(feature.values_, "voltage_type", "")
//             console.log(voltage_type)
//             // 过滤一遍
//             if (window.global.tideWayVoltageLevel.indexOf(voltage_type) != -1) {
//                 let fetProp = window.common.getFeatureProperties(feature);
//                 let idField = window.common.safeGetJsonKey(jl, "idfield", window.global.mapCfg.text.idfield);
//                 let tid = window.common.safeGetJsonKey(fetProp, idField, "");
//                 let end_st_id = window.common.safeGetJsonKey(fetProp, "end_st_id", "");
//                 let start_st_id = window.common.safeGetJsonKey(fetProp, "start_st_id", "");
//                 let idItem = {
//                     "id": tid,
//                     "start_st_id": start_st_id,
//                     "end_st_id": end_st_id,

//                 }
//                 lineIdList.push(idItem)
//                 lineList.push(feature)
//             }
//         }

//     }
//     console.log(lineList)
//     console.log(lineIdList)


//     postTideWayList(lineIdList,lineList)
//     // 发送给后台，返回数据
// }

// function postTideWayList(lineIdList,lineList,index,res) {
//     let url = "/gis/public/api/lineTide";
//     var params = lineIdList
//     let listData = [];
//     window
//         .axios({
//             method: "post",
//             url: url,
//             data: params,
//         })
//         .then((resp) => {
//             console.log(resp)
//             if (resp.status == 200) {
//                 let  data=resp.data

//                 let pointList = []
//                 // 时间复杂度：2n
//                 let arr2Map = {};
//                 data.forEach((item) => arr2Map[item.id] = item)
//                 lineList.forEach((item) => {
//                     if (arr2Map[item.values_.id]) {
//                         item.direction = arr2Map[item.values_.id].direction;
//                         pointList.push(item);
//                     }


//                 })
//                 console.log(pointList)
//                 window.mapHeatLine.featureGeted(index, res, pointList);
//                 // for (let key in lineList) {
//                 //     // for (let x = 0; x < data.length; x++){

//                 //     // }
//                 //     var points = [];
//                 //     let id = window.common.safeGetJsonKey(lineList[key].values_, "id", "")


//                 //     let coors = lineList[key]
//                 //         .getGeometry().getCoordinates()

//                 //     let startPos = []
//                 //     let n = coors.length - 1;
//                 //     let random = Math.random()
//                 //     if (random < 0.5) {
//                 //         startPos = coors[0]
//                 //     } else {
//                 //         startPos = coors[n]
//                 //     }

//                 //     startPos = transform(startPos, 'EPSG:3857', 'EPSG:4326');
//                 //     console.log(startPos)
//                 //     let fhead = [120, 30]

//                 //     for (let i = 0, p = 0; i < coors.length; i++) {
//                 //         // pointList.push(transform(coors[i], 'EPSG:3857', 'EPSG:4326'));
//                 //         if (coors[i][0] < 0 || coors[i][1] < 0)
//                 //             continue;
//                 //         let t = transform(coors[i], 'EPSG:3857', 'EPSG:4326');
//                 //         points[p] = t;
//                 //         p++;

//                 //     }
//                 //     pointList.push(points);
//                 //     console.log(pointList)

//                 // }
//                 // window.mapHeatLine.trendGeted(pointList, []);

//             }
//         });

// }





function addClickEvent() {

    window.global.map.on('singleclick', function (event) {
        clearLocationFlag()//清除查询的点亮
        // window.global.tree_overlay.setPosition(undefined);8  
        let curZoom = window.common.getMapZoomFloat(); //获取当前地图的缩放级别
        let iCurZoom = window.common.getMapZoomInt()

        if (window.global.menu_overlay != null)
            window.global.menu_overlay.setPosition(undefined);

        window.mapWeather.closeWeatherTip();

        if (window.global.point_overlay != null) {
            window.global.point_overlay.setPosition(undefined);
        }
        window.mapBase.clearbreakDownLayerFeatuer();

        let t = transform(event.coordinate, 'EPSG:3857', 'EPSG:4326');
        clickList.push(t.join(","))
        console.log("LineString(" + clickList.join("  ") + ")")
        let m = window.global.map.getView().calculateExtent(window.global.map.getSize())
        let m0 = transform([m[0], m[1]], 'EPSG:3857', 'EPSG:4326')
        let m1 = transform([m[2], m[3]], 'EPSG:3857', 'EPSG:4326')
        let s = transform(window.global.map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326')
        let zoom_size = window.global.map.getView().getZoom();
        console.log("地图范围：" + m0 + "  " + m1 + "地图中心位置：" + s, zoom_size)
        console.log("地图范围：" + m0 + "," + m1)
    });

    window.global.map.on('contextmenu', function (event) {
        event.preventDefault();
        selectOneFeature(event);
    });
}

//拖拽点时地图禁止移动
var pan;
function flagOnMove(flag) {
    window.global.map.getInteractions().forEach(function (el, ind, arr) {
        if (el instanceof DragPan) {
            pan = el
            pan.setActive(flag)
        }

    })
}
function changeMoveItem(id, geo) {
    if (window.global.moveArray && window.global.moveArray.length) {
        let center = transform(geo, 'EPSG:3857', 'EPSG:4326');
        window.global.moveArray.map((item) => {
            if (item.ID == id) {
                item.LNG = center[0]
                item.LAT = center[1]
            }
        })
        var event = null
        if (window.global.moveType == 'line') {
            event = new Event('changMoveValueL')
        } else {
            event = new Event('changMoveValueP')
        }

        window.dispatchEvent(event)


    }
}
//判断点击的是不是要移动的id
function isMove(id,evt) {
    console.log(id,'idid')
    if(window.showPopup){
        
        window.showPopup(id,evt.coordinate)
    }
    let flag = false
    if (window.global.moveArray && window.global.moveArray.length) {
        window.global.moveArray.map((item) => {
            if (item.ID == id) {
                flag = true
            }
        })
    }
    return flag
}



//点击事件判断

//拖拽
var dragging = false//是否正在拖拽
var dragPoint = null//拖拽的点

function dragPoints() {
    window.global.map.on('pointermove', function (evt) {

        if (dragging) {
            var coordinate = window.global.map.getEventCoordinate(evt.originalEvent)
            if (dragPoint) {
                // console.log(selected, 'selected')
                dragPoint.getGeometry().setCoordinates(coordinate)
                changeMoveItem(selected.values_.id, coordinate)
            }
        } 
    })
}
//落下
var selected = null //当前选中的要素

function pointDown() {
    window.global.map.on('pointerdown', function (evt) {
        if (evt) {
            var feature = window.global.map.forEachFeatureAtPixel(evt.pixel, function (feature) { return feature })
            if (feature && feature.getGeometry().getType() == "Point" && feature.get('name') == 'test') {
                console.log(feature,'feature')
                if (isMove(feature.values_.id,evt)) {
                    selected = feature
                    dragging = true
                }
                if (selected) {
                    console.log('落下')
                    flagOnMove(false)
                    dragging = true
                    dragPoint = selected
                }
            } else {
                selected = null
            }
        }

    })
}
//抬起

function pointUp() {
    window.global.map.on('pointerup', function (evt) {
        console.log('抬起')
        flagOnMove(true)
        // if (dragPoint) {//用于线的拖拽,通知线更新
        //     var event = new Event('changMoveValueL')
        //     window.dispatchEvent(event)
        // }
        dragging = false
        dragPoint = null


    })
}

//

let hitTolerance = 10;
var featureSelected = 0;
function selectOneFeature(e) {
    featureSelected = 0;
    window.mapBase.stopWeatherTipTimer();
    let ct = e.coordinate
    let selectFeatuerList = []
    window.global.map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
        // feature.values_ && console.log(feature.values_.name,feature,layer)
        let jl;
        let feature_select;
        if (layer == window.global.displayLabelLayer) {
            jl = feature.values_.layer;
            feature = feature.values_.fixedFeature;
        }
        // else if (layer == window.global.windLayer || layer ===window.global.weatherLayer) {
        //     jl = feature.values_.layer;
        //     feature = feature.values_.fixedFeature;
        // }
        else if (layer == window.global.aisaLayerLayer) {
            jl = feature.values_;
            // feature = feature.values_.item;
        }
        else if (layer == displayLinePathLayer) {
            jl = feature.values_;
            // feature =feature.values_.featureItem
        }
        else {
            jl = window.mapBase.getLayerCfgBylayer(layer);
        }
        if (jl == null)
            return;
        if (!jl.leftMenu)
            return;
        selectFeatuerList.push([feature, jl])
    },
        {
            hitTolerance: hitTolerance,
            //点击时允许鼠标的误差
        });

    if (selectFeatuerList.length == 0) {
        window.mapBase.clearDisplaySelectedSource();
        return
    }
    // if (selectFeatuerList.length>1)
    // {
    //     // popup menu

    //     window.setTreeOverLayData  && window.setTreeOverLayData(selectFeatuerList,ct)
    // }
    // else
    {
        let feature = selectFeatuerList[0][0]
        let jl = selectFeatuerList[0][1]

        if (window.global.bdDialogVisible) {
            window.setSelectFeaturesList && window.setSelectFeaturesList(feature)
            window.addNewBdsb(true)
            return
        }
        if (window.global.editBdDialogVisible) {
            window.setSelectFeaturesList && window.setSelectFeaturesList(feature)
            window.addNewBdsb(true)
            return
        }


        featureSelected = 1;
        let jlType = window.common.safeGetJsonKey(jl, "type", "");
        if (jlType == "asia") {
            let cmc = window.global.contextMenuCfg.leftClick.asia;
            window.common.safeGetJsonKey(jl, "classNameField", window.global.mapCfg.field.classNameField)
            let turl = cmc.url;
            let className = "venue"
            let tname = window.common.safeGetJsonKey(jl, "name", "")
            let tid = window.common.safeGetJsonKey(jl, "id", "")
            let zyId = window.common.safeGetJsonKey(jl, "zyId", "")
            // window.zyName=tname;
            let deviceType = ""
            //http://10.33.64.123:8081/powerSafeCard/13chongfule
            turl = turl + "/" + zyId;
            let item = {
                divider: 0,
                title: "",
                width: cmc.width,
                height: cmc.height,
                icon: cmc.icon,
                id: tid,
                name: tname,
                className: deviceType,
                url: turl,
                linkType: "url",
            };
            window.setVenueCardItem(item);

            return

        }
        let fetProp = window.common.getFeatureProperties(feature);
        let classNameField = window.common.safeGetJsonKey(jl, "classNameField", window.global.mapCfg.field.classNameField);
        let className = window.common.safeGetJsonKey(fetProp, classNameField, "");
        let voltageFiled = window.common.safeGetJsonKey(jl, "voltageFiled", window.global.mapCfg.field.voltageFiled);
        let voltageType = window.common.safeGetJsonKey(fetProp, voltageFiled, "");
        let nameField = window.common.safeGetJsonKey(jl, "textfield", window.global.mapCfg.text.textfield);
        let tname = window.common.safeGetJsonKey(fetProp, nameField, "");

        let idField = window.common.safeGetJsonKey(jl, "idfield", window.global.mapCfg.text.idfield);
        let tid = window.common.safeGetJsonKey(fetProp, idField, "");

        let tgeolayerName = window.common.safeGetJsonKey(fetProp, "layer", "");
        let coordinate = e.coordinate;
        let pos = transform(coordinate, 'EPSG:3857', 'EPSG:4326')
        pos = [parseFloat(pos[0].toFixed(4)), parseFloat(pos[1].toFixed(4))]
        let tgeolayerNameTypeField = window.common.safeGetJsonKey(fetProp, "class_name", "");
        let tgeolayerNameType = window.common.safeGetJsonKey(window.global.dataTypes, tgeolayerNameTypeField, "");
        let tpower
        // console.log(fetProp)
        // console.log(tname, tid, fetProp, className, tgeolayerName);
        // window.global.dataTypes
        window.global.layerCfg.forEach((item) => {
            // console.log(item.geolayerName)
            if (item.geolayerName == tgeolayerName) {
                console.log(item.title)
                tgeolayerNameType = item.title
            }
        })
        window.global.tidwayFeatureAll.forEach((item) => {
            if (item.id == tid) {
                // console.log(item)
                tpower = Math.abs(item.start_aclineend_val) + Math.abs(item.end_aclineend_val)
            }
        })
        let deviceType = window.common.safeGetJsonKey(fetProp, "class_name", "CONVERSUBSTATION");
        deviceType = deviceType.toUpperCase();

        if (tid != "" && window.global.gdljShow) {
            getConnectPathGroups(tid, tgeolayerName.geolayerName);
            return
        } else if (tid != "" && !window.global.gdljShow) {
            getConnectPath(tid, deviceType)
        }

        if (tid != "" && window.global.powerinfoShow) {
            let cmc = window.global.contextMenuCfg.leftClick.powerinfo;
            let turl = cmc.url;
            if (turl.indexOf("?") == -1) { turl += "?class_name=" + className + "&id=" + tid; }
            else { turl += "&class_name=" + className + "&id=" + tid; }

            let item = {
                divider: 0,
                title: "",
                width: cmc.width,
                height: cmc.height,
                icon: cmc.icon,
                id: tid,
                name: tname,
                className: deviceType,
                url: turl,
                linkType: "url",
            };
            window.setVenueCardItem(item);
            return
        }

        let isSg;
        if (deviceType == "ACLINE" || deviceType == "SUBSTATION" || deviceType == "PLANT" || deviceType == "DCLINE" || deviceType == "CONVERSUBSTATION" || deviceType == "") {
            isSg = true;
        }
        else
            isSg = false;
        if (window.global.weatherLayer != null || window.global.windLayer != null) {


            let cmc = window.global.contextMenuCfg.leftClick.weather;
            let turl = cmc.url;
            // name=双浦变&id=01123302000038
            if (turl.indexOf("?") == -1) { turl += "?name" + tname + "&id=" + tid; }
            else { turl += "&name=" + tname + "&id=" + tid; }
            let item = {
                divider: 0,
                title: "",
                width: cmc.width,
                height: cmc.height,
                icon: cmc.icon,
                id: tid,
                name: tname,
                className: deviceType,
                url: turl,
                linkType: "url",
            };
            window.setShowIframe(item);

        }
        else if (0) {

        }
        else {

            if (isSg) {
                let Api = "";
                let masterCardUrl = window.global.mapCfg.masterCardUrl
                if (deviceType == "ACLINE") {
                    // 交流http://localhost:8088/card/getAclineCardInfo?id=120699010000000030
                    Api = `${masterCardUrl}/getAclineCardInfo?id=${tid}`
                }
                else if (deviceType == "SUBSTATION") {
                    //url=`http://10.33.8.213:8088/card/getCardInfo?id=${tid}`
                    Api = `${masterCardUrl}/getCardInfo?id=${tid}`
                }
                else if (deviceType == "PLANT") {
                    //电厂http://localhost:8088/card/getPlantCardInfo?id=01113308810008
                    Api = `${masterCardUrl}/getPlantCardInfo?id=${tid}`
                }
                else if (deviceType == "DCLINE") {
                    // 直流http://localhost:8088/card/getDclineCardInfo?id=120699010000000030
                    Api = `${masterCardUrl}/getDclineCardInfo?id=${tid}`
                }
                else if (deviceType == "CONVERSUBSTATION") {
                    Api = `${masterCardUrl}/getConverSubstationCardCardInfo?id=${tid}`
                }
                try {
                    window.axios.get(Api).then(
                        res => {
                            var msgData = JSON.stringify({
                                type: 'renderCard',
                                data: res.data.data
                            });
                            window.top.postMessage(msgData, '*');
                        }
                    )
                } catch (e) {
                    return console.log(e)

                }


            } else {
                // let cmc = window.global.contextMenuCfg.leftClick.dwyzt;
                // let turl = cmc.url;
                // if (turl.indexOf("?") == -1) { turl += "?class_name=" + className + "&id=" + tid; }
                // else { turl += "&class_name=" + className + "&id=" + tid; }
                // let item = {
                //     divider: 0,
                //     title: "",
                //     width: cmc.width,
                //     height: cmc.height,
                //     icon: cmc.icon,
                //     id: tid,
                //     name: tname,
                //     className: deviceType,
                //     url: turl,
                //     linkType: "url",
                // };
                // window.setShowIframe(item);

            }


        }

        if (tid != "" && window.global.gdljShow) {
            // getConnectPath(tid, tgeolayerName);
            getConnectPathGroups(tid, tgeolayerName.geolayerName);
        } else if (tid != "" && !window.global.gdljShow) {
            getConnectPath(tid, deviceType)
        }

    }


    // var features = e.target.getFeatures().getArray();
    // let overlayPopup = document.getElementById("overlayPopup");
    // closeOverlayPopup();
    // if (features.length > 0) {
    //     var feature = features[0];
    //     var type = feature.getGeometry().getType();
    //     var coordinate = ol.extent.getCenter(feature.getGeometry().getExtent());
    //     overlayPopup.style.display = 'block';
    //     popupLayer.setElement(overlayPopup);
    //     popupLayer.setPosition(coordinate);
    //     displayFeatureInfo(feature,coordinate)

    // }
    //e.target.getFeatures().clear();
}
//

// addFeature2list



function addDispayLinePathLayer() {
    displayLinePathStyle = new Style({
        fill: new olFill({
            color: window.global.layerStyleCfg.linePath_style.fill
        }),
        stroke: new Stroke({
            color: window.global.layerStyleCfg.linePath_style.color, //颜色
            width: parseInt(window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style, "width", 2)), //宽度
            lineCap: window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style, "lineCap", "round"), //线帽样式
            //butt：末端添加平直边缘；round：末端添加圆形线帽；square：末端添加方形线帽；
            lineJoin: window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style, "lineJoin", "round"), //线条连接处样式
            //bevel：创建斜角；round：创建圆角；square：创建尖角；
        }),
        image: new olIcon({
            anchor: [0, 0], //设置图标偏移
            scale: 0.5, // 图标缩小显示
            anchorOrigin: 'top-left', //标注样式的起点位置
            anchorXUnits: 'pixels', //X方向单位：分数
            anchorYUnits: 'pixels', //Y方向单位：像素
            offsetOrigin: 'center', //偏移起点位置的方向
            opacity: 0.9, //透明度
            rotateWithView: false,
            offsetX: 0,
            offsetY: -10,
            rotation: 0,
            src: 'img/school.png'
        }),
        text: new olText({
            rotateWithView: true,
            overflow: true,
            rotation: 0,
            placement: "point",
            font: window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style.text, "fontSize", window.global.mapCfg.text.fontSize)
                + " " + window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style.text, "text", window.global.mapCfg.text.font),
            offsetX: parseInt(window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style.text, "offsetX", window.global.mapCfg.text.offsetX)),
            fill: new olFill({
                color: window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style.text, "bordercolor", window.global.mapCfg.text.bordercolor),
            }),
            stroke: new Stroke({
                color: window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style.text, "color", window.global.mapCfg.text.color),
                width: window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style.text, "width", window.global.mapCfg.text.width),
            }),
        })
    });

    displayLinePathVectorSource = new Vector;
    displayLinePathLayer = new VectorLayer({
        url: "",
        title: "displayLinePathLayer_inner",
        source: displayLinePathVectorSource
    });
    let t = window.global.map.getLayers().getLength();
    displayLinePathLayer.setZIndex(6);
    window.global.map.addLayer(displayLinePathLayer);
}

function setLayerTempVisible(layerName, isVisible) {
    //0 hidden 1 display
    //layyer look at layer_style.js(json)
    let jl = null;
    let pos = 0;

    let layerList = [];
    let appendLabelLayer = false;
    let curZoom = window.common.getMapZoomInt();
    //获取当前地图的缩放级别
    window.setInfoZoom(curZoom)
    console.log('setLayerTempVisible')
    while (true) {
        let p = window.mapBase.getLayerByName(layerName, pos);
        jl = p[0];
        pos = p[1];


        if (jl == null)
            break;
        pos++;
        jl.tempVisible = parseInt(isVisible) == 1 ? 1 : 0;
        jl.tempMinZoom = curZoom;
        let ly = jl.ol;
        if (ly == null)
            continue;
        if (jl.tempVisible == 0) {//0 means temp force hide
            if (ly.getVisible())
                ly.setVisible(false);
            jl.loadRenderStep = 0;
        }
        else {
            if (!ly.getVisible()) {
                ly.setVisible(true);
                layerList.push(jl);
            }

        }

        if (jl.displayByLabel)
            appendLabelLayer = true;


    }
    window.mapBase.cleanDisplayLayer();
    window.mapBase.refreshGeoLayer(layerList, appendLabelLayer);
}

function removeLayerEx(exLayerList, isVisible, closeBy) {
    for (let i = 0; i < window.global.layerCfg.length; i++) {
        let jl = window.global.layerCfg[i];
        if (jl == null)
            continue;
        if (exLayerList.includes(jl.name))
            continue;
        if (jl.ol == null)
            continue;
        if (!jl.hasOwnProperty(closeBy))
            jl[closeBy] = false;
        if (isVisible == 0) {
            jl[closeBy] = true;
            jl.visible = isVisible;
            // jl.ol.setVisible(false);
            window.global.map.removeLayer(jl.ol);
            jl.ol = null

        }
    }
}



function setLayerVisible(layerName, isVisible) {
    //0 hidden 1 display
    //layyer look at layer_style.js(json)
    let jl = null;
    let pos = 0;

    while (true) {
        let p = window.mapBase.getLayerByName(layerName, pos);
        jl = p[0];
        pos = p[1];
        if (jl == null)
            break;
        pos++;
        jl.visible = isVisible;
        let ly = jl.ol;
        if (ly == null)
            continue;
        if (jl.visible == 0) {//0 means temp force hide
            if (ly.getVisible())
                ly.setVisible(false);
        }
        else {
            if (!ly.getVisible()) {
                ly.setVisible(true);
                ly.getSource().refresh();
            }
        }
    }
}

function getMyCenterLocation() {
    return transform(window.global.map.getView().getCenter(), 'EPSG:3857', 'EPSG:4326');
}


function showSearchResultFeature(id, className, ft, name, isMove2Center, projCode) {

    let feature = eval('(' + ft + ')');
    //在查找到结果后，用户点击结果对象时调用。
    // let zoom_size = map.getView().getZoom();

    // if(zoom_size<zoomInfo){
    // 	setMapZoom(zoomInfo);
    // }
    let olfeatureA = null;
    let olfeatureB = null;
    if (id != "") {
        // window.postMsg2DevTree(id, className);
    }
    console.log(feature.type,'type')
    if (feature.type == "Point") {
        let pos;
        if (projCode == '4326')
            pos = transform(feature.coordinates, 'EPSG:4326', 'EPSG:3857');
        else
            pos = feature.coordinates;
        olfeatureA = new Feature({
            geometry: new Point(pos), //几何信息
            name: name,
            featureItem: feature,
            id: id,
            name: name,
            className: className
        });

        olfeatureA.setStyle(() => {
            return new Style({
                image: new olIcon({
                    anchor: [0.5, 1],
                    rotateWithView: true,
                    src: "img/gis/location.png"
                })
            })
        }); //设置要素样式
        displayLinePathVectorSource.addFeature(olfeatureA);

        // let zoom_size = window.common.getMapZoomInt();
        // let zoomInfo = parseInt(window.global.mapCfg.displayFeatureZoom);
        // if (zoom_size < zoomInfo) {
        //     window.mapBase.setMapZoom(zoomInfo);
        // }

        if (isMove2Center) {
            let zoom_size = window.common.getMapZoomInt();
            let zoomInfo = parseInt(window.global.mapCfg.displayFeatureZoom);
            if (zoom_size < zoomInfo) {
                window.mapBase.setMapZoom(zoomInfo);
            }
            let coordinate = getFeatureCenter(olfeatureA.getGeometry().getExtent());
            pos = transform(coordinate, 'EPSG:3857', 'EPSG:4326')
            window.mapBase.setMapCenter(pos[0], pos[1]);
            // window.vueAddRedPoint();

            addMarkAniFlag(pos[0], pos[1]);
        }

    }

    else if (feature.type == "LineString" || feature.type == "MultiLineString") {
        let pointList = []
        let pointTList = []
        if (feature.type == "LineString") {
            if (projCode == '4326') {
                for (let i = 0; i < feature.coordinates.length; i++) {
                    pointList.push(transform(feature.coordinates[i], 'EPSG:4326', 'EPSG:3857'));
                }
            }
            else {
                for (let i = 0; i < feature.coordinates.length; i++) {
                    pointList.push(feature.coordinates[i]);
                }
            }
            olfeatureA = new Feature({
                geometry: new LineString(pointList), //几何信息
                name: name,
                featureItem: feature,
                leftMenu: 1,
                id: id,
                name: name,
                class_name: className,
            });
            olfeatureB = new Feature({
                geometry: new LineString(pointList), //几何信息
                name: name,
                featureItem: feature,
                leftMenu: 1,
                id: id,
                name: name,
                class_name: className,
            });
        }
        else {
            for (let i = 0; i < feature.coordinates.length; i++) {
                let coors = feature.coordinates[i];
                pointTList = []
                if (projCode == '4326') {
                    for (let i = 0; i < coors.length; i++) {
                        pointTList.push(transform(coors[i], 'EPSG:4326', 'EPSG:3857'));
                    }
                }
                else {
                    for (let i = 0; i < coors.length; i++) {
                        pointTList.push(coors[i]);
                    }
                }
                pointList.push(pointTList);

            }
            olfeatureA = new Feature({
                geometry: new MultiLineString(pointList), //几何信息
                name: name,
                featureItem: feature,
                leftMenu: 1,
                id: id,
                name: name,
                class_name: className,
            });
            olfeatureB = new Feature({
                geometry: new MultiLineString(pointList), //几何信息
                name: name,
                featureItem: feature,
                leftMenu: 1,
                id: id,
                name: name,
                class_name: className,
            });
        }


        let layerName = ""
        if (className == "PWFeederLinePSR") {
            layerName = "feedline"
        } else if (className == "ACLine" || className == "DCLine") {
            layerName = "dev_line"
        }

        let jl = window.mapBase.getLayerByName("feedline")[0];
        // olfeatureA.values_["layer"]=jl

        // let st=window.mapBase.getFeatureStyleEx(jl,olfeatureA,"geojson",1);
        // if(st==null)
        // {
        //     window.mapBase.getFeatureStyleEx(jl,olfeatureA,"fromShow");

        //     olfeatureA.setStyle(() => {
        //         return st;
        //     }); //设置要素样式;

        //     jl.ol.getSource().addFeature(olfeatureA);
        // }
        let selectSt = new Style({
            fill: new olFill({
                color: window.global.layerStyleCfg.linePath_style.fill
            }),
            stroke: new Stroke({
                color: window.global.layerStyleCfg.linePath_style.color, //颜色
                width: parseInt(window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style, "width", 2)), //宽度
                lineCap: window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style, "lineCap", "round"), //线帽样式
                //butt：末端添加平直边缘；round：末端添加圆形线帽；square：末端添加方形线帽；
                lineJoin: window.common.safeGetJsonKey(window.global.layerStyleCfg.linePath_style, "lineJoin", "round"), //线条连接处样式
                //bevel：创建斜角；round：创建圆角；square：创建尖角；
            }),
        });
        olfeatureB.setStyle(() => {
            return selectSt;
        }); //设置要素样式;
        let st = window.mapBase.getFeatureStyleEx(jl, olfeatureA, "fromShow");
        let selectedStyle = []
        if (st instanceof Array) {
            selectedStyle = st;
            selectedStyle.push(selectSt);

        }
        else {
            selectedStyle.push(st);
            selectedStyle.push(selectSt);
        }

        olfeatureB.setStyle(() => {
            return selectedStyle;
        }); //设置要素样式;
        olfeatureB.values_["layer"] = jl

        displayLinePathVectorSource.addFeature(olfeatureB);
        if (isMove2Center) {
            // 定位中心区域
            let fExtent = olfeatureB.getGeometry().getExtent();
            let w = (fExtent[2] - fExtent[0]) / 2;
            let h = (fExtent[3] - fExtent[1]) / 2;
            fExtent[0] -= w;
            fExtent[1] -= h;
            fExtent[2] += w;
            fExtent[3] += h;
            window.global.map.getView().fit(fExtent, {
                constrainResolution: true,
                nearest: true,
                minResolution: window.global.map.getView().getResolutionForZoom(15),
                maxResolution: window.global.map.getView().getResolutionForZoom(17),
            })
        }
    }




}
function createElementMarkAniLayer() {
    var point_div = document.createElement('div');
    point_div.className = "css_central_location_animation";
    window.global.point_overlay = new Overlay({
        element: point_div,
        positioning: 'center-center',
    });

    window.global.map.addOverlay(window.global.point_overlay);
}





function addMarkAniFlag(lon, lat) {
    //设置点击事件位置
    let currentEmergencyLocation = transform([lon, lat], 'EPSG:4326', 'EPSG:3857');
    //设置点击事件的样式
    window.global.point_overlay.setPosition(currentEmergencyLocation);
}
function setTracePathMode(enable) {

}


function clearLocationFlag() {
    if (displayLinePathVectorSource != null)
        displayLinePathVectorSource.clear(true);
}




function showBreakDownDisplayLabel(pos, displayText, fixedFeature, item, onlyOne, path) {

    let resolution = window.global.map.getView().getResolution();
    let curZoom = window.common.getMapZoomInt();
    let trigw_h = 6;
    let trigh = 25;


    let m = window.global.map.getView().calculateExtent(window.global.map.getSize());

    let fontSize = 16;
    let font = "宋体";
    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d', { willReadFrequently: true });
    let x = 0;
    let y = 0;
    let maxRow = 0, maxLenText;
    // let wh = window.common.computeFontSize(displayText, fontSize, font);

    let displyaTextList = window.common.getCommonStringSegment(displayText, fontSize, font, 16);
    displyaTextList.forEach(t => {
        if (maxRow < t.length) {
            maxRow = t.length;
            maxLenText = t;
        }
    });
    let wh = window.common.computeFontSize(maxLenText, fontSize, font);
    let w = wh.width + 20;

    let halfw = 0;
    if (path == 'queryPath') {
        halfw = w / 2 + 10;
        console.log(path, '----path1')
    } else {
        halfw = w * 2 / 3 + 8;
        console.log(path, '----path2')
    }
    let h = (wh.height + 2) * displyaTextList.length + 4;

    if (fixedFeature != null) {
        let feature = fixedFeature;
        let geom = feature.getGeometry();
        let coors = geom.getCoordinates();
        pos = coors[0];
    }
    else {
        pos = transform(pos, 'EPSG:4326', 'EPSG:3857');
    }


    let olfeature = new Feature({
        geometry: new Point(pos), //几何信息
        name: displayText,
        faultLabel: true,
        item: item
    });

    context.fillStyle = 'rgba(239, 239, 80, 0.9)';
    // context.fillStyle =' rgba(255, 255, 255, 0)';
    context.strokeStyle = 'rgba(122,54, 65, 1)';

    context.beginPath();
    context.moveTo(0, 0);
    context.lineTo(x, y + h);

    context.lineTo(x + halfw - trigw_h, y + h);
    context.lineTo(x + halfw, y + h + trigh);
    context.lineTo(x + halfw + trigw_h, y + h);

    context.lineTo(x + w, y + h);
    context.lineTo(x + w, y);
    context.lineTo(x, y);
    context.closePath();
    context.fill();
    context.stroke();
    context.font = fontSize + "px " + font;


    for (let i = 0; i < displyaTextList.length; i++) {
        context.strokeText(displyaTextList[i], 3, (wh.height + 2) * i + wh.height / 2 + 3);
    }

    olfeature.setStyle(() => {
        return new Style({
            image: new olIcon({
                img: canvas,
                imgSize: [w, h + trigh],
                anchor: [0.5, 1],
                // declutterMode:"declutter"
                // offsetX:-parseInt(w/2)-10,// parseInt(subObj.text.offsetX),
                // offsetY:parseInt(h/2)-3,
            })
        })
    }); //设置要素样式
    window.mapBase.appendbreakDownLayerFeatuer(olfeature, onlyOne);

    // console.log("drawLineDisplayLabel over");
}

// function replayUrlKeyword(url,tname,tid,[])
// {
//     url.replace('{name}',tname)
//     url.replace('{id}',id)
//     url.replace('{date}',ymd)
//     url.replace('{time}',hms)
//     url.replace('{y}',y)
//     url.replace('{position}',hms)
// }

export default {
    cleanLayerTempVisible,//自动调用，在图层放大缩小时，清除临时可见规则。
    updateLayerVisibleInfo,    //用于在图层控制组件中 显示当前视图中有哪些可见的层。（具体某一层是否可在window.global.layerCfg.json中配置）
    addClickEvent,//建立地图时调用，左键的事件.
    // pointClick,
    pointDown,
    pointUp,
    dragPoints,//点拖拽事件
    // addRightClickEvent,//建立地图时调用，右键的事件
    addDispayLinePathLayer,//建立地图时调用，显示上下级线路路径
    setLayerTempVisible,//开关临时图层 ，图层控制作界面，单选框点击后调有的函数
    showSearchResultFeature, //将地图的中心点移动feature所在位置 ，并改变地图的zoom,以适合显示,如果是线路要素，需要整条线路点亮
    setTracePathMode,
    clearLocationFlag,
    setLayerVisible,
    createElementMarkAniLayer,
    // getTideWayLineIdList,
    getMyCenterLocation,
    addMarkAniFlag,
    showBreakDownDisplayLabel,
    removeLayerEx,
    addEquemtTree,
    // postTideWayList,
}



//路径查找。
//菜单栏增加一个按钮，“路径追踪”,用户点击这个按键后，这个按钮显示锁住效果
//setTracePathMode(1)
//在clickEvent中，发现TracePathMode==1， 调用后台取到数据，
//把数据加到LinePathLayer
//点其它线路（要素）时，同样操作，显示的线路会越来越多。
//用用户再点“路径追踪”，按钮正常显示。
//在clickEvent中，点击，用正常功能（显示 一下要素信息）

